module.exports = __webpack_public_path__ + "img/New-College-t-26902-067.6cb2a7c5.jpg";